import React, { useState, useEffect, Fragment } from "react";
import { useDispatch, useSelector } from "react-redux";
import { makeStyles, withStyles } from "@material-ui/core/styles";
import { DataGrid } from "@material-ui/data-grid";
import Button from "@material-ui/core/Button";
import FullScreenDialog from "../../Dialog/FullScreenDialog";
import { rfiInboxListStyle } from "../../../styles/jss/components/RFI/rfiInboxListStyle";
import RFIDetailsForm from "././RFIDetailsForm";
import { getRFIList } from "../../../dataSource/rfi";
import MailIcon from "@material-ui/icons/Mail";
import DraftsIcon from "@material-ui/icons/Drafts";
import Tooltip from "@material-ui/core/Tooltip";
import LaunchIcon from "@material-ui/icons/Launch";

const useStyles = makeStyles((theme) => rfiInboxListStyle(theme));

const RFIInboxList = (props) => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [openDialog, setOpenDialog] = useState(false);
  const [rfiseq, setRfiseq] = useState("");
  const [list, setList] = useState([]);
  const [listMsg, setListMsg] = useState("");
  const { buildAlert } = props;
  const store = require("store");
  const userCategoryCode = store.get("user_category_code") || "";
  const isSubCon =
    userCategoryCode === "SUPPLIER" || userCategoryCode === "SUBCON";
  const isInternal = userCategoryCode === "SANFIELD";

  const getRFIListAction = async () => {
    getRFIList(props.is_draft).then((res) => {
      let rfilist = res.data.map((obj, index) => {
        return {
          id: ++index,
          ...obj,
        };
      });
      setList(rfilist);
      if (res.data.length === 0) {
        setListMsg("No RFI");
      } else {
        setListMsg("");
      }
    });
  };
  useEffect(() => {
    const fetchRFIList = async () => {
      await getRFIListAction();
    };
    fetchRFIList();
  }, [openDialog, setOpenDialog]);

  const columns = [
    {
      field: "id",
      hide: "true",
    },
    {
      field: "is_read",
      renderCell: (params) =>
        params.value === "N" ? (
          <Tooltip title="Unread RFI">
            <MailIcon className={classes.readedIcon} />
          </Tooltip>
        ) : (
          <Tooltip title="Readed RFI">
            <DraftsIcon className={classes.unreadIcon} />
          </Tooltip>
        ),

      headerName: " ",
      width: 50,
    },
    {
      field: "rfi_seq",
      renderCell: (params) => (
        <Tooltip title="View RFI">
          <LaunchIcon
            className={classes.viewIcon}
            onClick={() => {
              showRFIDetails(params);
            }}
          />
        </Tooltip>
      ),
      headerName: " ",
      width: 50,
    },
    { field: "ref_no", headerName: "Ref. No.", width: 300 },
    { field: "stage", headerName: "Stage", width: 200 },
    { field: "subject", headerName: "Subject", width: 400 },
    { field: "issue_by", headerName: "Issue By", width: 250 },
    { field: "category", headerName: "Category", width: 250 },
    { field: "last_update_date", headerName: "Last Update Date", width: 200 },
  ];

  const showRFIDetails = (params) => {
    setOpenDialog(true);
    setRfiseq(params.value);
  };
  // const list = [];

  return (
    <Fragment>
      <div style={{ width: "100%" }}>
        <DataGrid rows={list} columns={columns} pageSize={10} />
      </div>
      {
        <div className={classes.detailsFullScreen}>
          <FullScreenDialog
            open={openDialog}
            dialogTitle={"RFI Details"}
            formContent={
              <RFIDetailsForm
                rfiSeq={rfiseq}
                isSubCon={isSubCon}
                isInternal={isInternal}
                isNew={false}
                openDialog={openDialog}
                setOpenDialog={setOpenDialog}
                buildAlert={buildAlert}
              ></RFIDetailsForm>
            }
            button={[]}
            handleClose={() => {
              setOpenDialog(false);
            }}
          ></FullScreenDialog>
        </div>
      }
    </Fragment>
  );
};

export default RFIInboxList;
